import { getCarHireFAQ } from 'components/CarHire/CarHireHardcodedLists'
import LayoutContainer from 'components/Common/LayoutContainer'
import Sheet from 'components/utils/Sheet'
import Accordion from 'LuxKit/Accordion'
import MarkdownRender from 'LuxKit/MarkdownRender'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { isCarHireInsuranceAvailable } from 'selectors/carHireSelectors'

interface MappedProps {
  isCarHireInsuranceAvailable: boolean
}

interface Props extends MappedProps {
}

function CarsCarHireFAQs(props: Props) {
  const { isCarHireInsuranceAvailable } = props
  const intl = useIntl()

  return (
    <Sheet padding="40 0" tabletPadding="60 0">
      <LayoutContainer variant="medium">
        <Heading variant="heading3" align="center">
          {intl.formatMessage({
            id: 'TAfz8krzDH1_KfbefRzm',
            defaultMessage: 'Frequently asked questions',
            description: 'Section heading for the frequently asked questions area on the offer page',
          })}
        </Heading>
        {getCarHireFAQ(isCarHireInsuranceAvailable, intl).map((item) => (
          <Accordion
            key={item.question}
            startIcon={item.icon}
            heading={item.question}
            size="large"
          >
            <MarkdownRender
              fontSize="medium"
              content={item.answer}
              type="compact"
            />
          </Accordion>
        ))}
      </LayoutContainer>
    </Sheet>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isCarHireInsuranceAvailable: isCarHireInsuranceAvailable(state),
  }
}

export default connect(mapStateToProps)(CarsCarHireFAQs)
